module.exports = __webpack_public_path__ + "img/desburocratizacao_bronze.c86d8c89.png";